import { render, staticRenderFns } from "./DeliveryTemplateAddForm.vue?vue&type=template&id=28ea8048&"
import script from "./DeliveryTemplateAddForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryTemplateAddForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports